module.exports = __webpack_public_path__ + "static/media/Snowflake.dc72d2f5.jpg";